export default {
  // 모듈 헤더
  header: {
    title: '여행',
    subtitle: '스마트 일정 추천, AI 영수증 인식',
  },

  common: {
    close: '닫기',
  },

  // 여행 카드
  travelCard: {
    status: {
      active: '활성',
      planning: '계획 중',
      completed: '완료',
      cancelled: '취소됨',
    },
    actions: {
      viewDetails: '세부 정보 보기',
      joinTravel: '여행 참여',
      editTravel: '여행 수정',
      enterChat: '채팅 입장',
    },
    info: {
      members: '멤버',
      budget: '예산',
      duration: '기간',
      days: '일',
      perPerson: '/ 인',
      noLocation: '위치가 설정되지 않음',
      noBudget: '예산이 설정되지 않음',
      noMembers: '아직 멤버 없음',
      memberCount: '{{count}} 멤버',
      memberCount_plural: '{{count}} 멤버',
      actualCost: '실제 비용',
      public: '공개',
      friendsOnly: '친구 전용',
      private: '비공개',
    },
    dates: {
      to: '~',
      startDate: '출발일',
      endDate: '귀국일',
    },
  },

  // 여행 목록
  travelList: {
    loading: {
      title: '여행 목록 로드 중...',
      subtitle: '잠시만 기다려 주세요',
    },
    empty: {
      title: '아직 프로젝트가 없습니다',
      subtitle: '오른쪽 상단 버튼을 클릭하여 첫 프로젝트를 생성하세요',
    },
    messages: {
      error: '오류',
      fetchListFailed: '프로젝트 목록을 가져오지 못했습니다',
      unknownError: '알 수 없는 오류',
      likeFailed: '좋아요 작업이 실패했습니다',
    },
  },

  // 여행 생성
  createTravel: {
    // 페이지 헤더
    header: {
      title: '여행 생성',
      subtitle: '프로젝트 정보를 입력하세요',
    },
    title: '여행 생성',
    // 기본 정보
    projectName: '프로젝트 이름',
    projectNamePlaceholder: '여행 이름을 지정하세요',
    dateRange: '여행 날짜',
    startDate: '출발일',
    endDate: '귀국일',
    // 목적지
    destination: '목적지',
    selectCountry: '국가 선택',
    selectCity: '도시 선택',
    customCity: '또는 사용자 지정 도시 입력',
    customCityPlaceholder: '도시 이름을 입력하세요 (예: 파리, 도쿄, 뉴욕)',
    destinationLabel: '목적지: ',
    // 여행 선호도
    travelPreferences: '여행 선호도',
    preferencesSubtitle: '관심 있는 항목을 선택하여 AI가 일정을 맞춤화하도록 돕습니다',
    multiSelect: '(다중 선택 가능)',
    // 선호도 옵션
    preferences: {
      culture: '문화',
      food: '음식',
      scenery: '풍경',
      history: '역사',
      deepTour: '심층 투어',
      checkin: '체크인',
    },
  // 프로젝트 설명
  projectDescription: '프로젝트 설명',
  editItinerary: '일정 편집',
    descriptionPlaceholder: '이 여행의 특징과 하이라이트를 소개하세요...',
    aiGenerate: 'AI 스마트 설명 생성',
    aiGenerating: '생성 중...',
    // 결제 모드
    paymentMode: '결제 모드',
    prepayAverage: '사전 균등 결제',
    prepayAverageDesc: '사전에 고정 금액을 징수, 균등 분할',
    prepayShare: '사전 셰어 결제',
    prepayShareDesc: '사전에 고정 금액을 징수, 셰어 기준으로 분할',
    actualAverage: '실제 비용 (균등)',
    actualAverageDesc: '실제 비용을 나중에 균등 분할',
    actualShare: '실제 비용 (셰어)',
    actualShareDesc: '실제 비용을 나중에 셰어 기준으로 분할',
    // 결제 통화
    settlementCurrency: '결제 통화',
    selectCurrency: '통화 선택',
    // 통화 이름
    currencies: {
      CNY: '중국 위안',
      USD: '미국 달러',
      EUR: '유로',
      JPY: '일본 엔',
      GBP: '영국 파운드',
      AUD: '호주 달러',
      CAD: '캐나다 달러',
      CHF: '스위스 프랑',
      HKD: '홍콩 달러',
      SGD: '싱가포르 달러',
      KRW: '한국 원',
      TWD: '대만 달러',
      THB: '태국 바트',
      MYR: '말레이시아 링깃',
    },
    // 1인당 예산
    budgetPerPerson: '1인당 예산',
    budgetPlaceholder: '0',
    budgetUnit: '/ 인',
    budgetHint: '예산 계획 및 멤버 참조를 위한 1인당 예상 비용',
    // 프로젝트 공개 설정
    projectVisibility: '프로젝트 공개 설정',
    visibilitySubtitle: '여행 프로젝트를 보거나 참여할 수 있는 사람을 선택하세요',
    friendsVisible: '친구 공개',
    friendsVisibleDesc: '친구가 보고 참여 신청할 수 있습니다',
    privateProject: '비공개 프로젝트',
    privateProjectDesc: '친구만 초대 가능',
    // 배경 이미지
    backgroundImage: '배경 이미지',
    selectBackground: '배경 선택',
    backgroundPlaceholder: '클릭하여 배경 이미지를 선택하세요',
    selectBackgroundPlaceholder: '배경 이미지를 선택하려면 클릭',
    backgroundImages: {
      beach: '해변 휴가',
      churches: '교회 건축',
      airplane: '비행 여행',
      cruise: '크루즈 여행',
      fuji: '후지산',
      germany: '독일 풍경',
      holland: '네덜란드 풍차',
      hongkong: '홍콩 야경',
      korea: '한국 풍경',
      london: '런던의 인상',
      maldives: '몰디브',
      mountain: '산악 설경',
      paris: '파리의 로맨스',
      sakura: '벚꽃',
      sea: '푸른 바다',
      shanghai: '상하이 풍경',
      singapore: '싱가포르의 인상',
      snow: '눈 내림',
      sunrise: '일출',
      sunsets: '일몰',
      swiss: '스위스 풍경',
      thailand: '태국 스타일',
      vietnam: '베트남의 인상',
      waterfalls: '폭포 풍경',
    },
    // 버튼
    createProject: '여행 프로젝트 생성',
    next: '여행 생성',
    // 알림 메시지
    alerts: {
      hint: '힌트',
      success: '성공',
      error: '오류',
      enterProjectName: '프로젝트 이름을 입력하세요',
      selectDestination: '목적지를 선택하세요',
      selectDestinationCity: '목적지 도시를 선택하세요',
      enterProjectDescription: '프로젝트 설명을 입력하세요',
      invalidDateRange: '종료일은 시작일보다 이전일 수 없습니다',
      generatedSuccess: 'AI 설명 생성이 성공했습니다!',
      generateFailed: 'AI 생성이 실패했습니다',
      aiGenerationFailed: 'AI 생성이 실패했습니다',
      errorDetails: '오류 세부 정보',
      createSuccess: '여행 프로젝트가 성공적으로 생성되었습니다!',
      createSuccessMessage: '여행 프로젝트가 생성되었습니다. 친구를 초대하세요!',
      createFailed: '생성 실패',
      createFailedMessage: '네트워크 연결을 확인하고 다시 시도하세요',
      createFailedDetail: '문제가 지속되면 고객 서비스에 문의하세요.',
      userNotLoggedIn: '사용자가 로그인하지 않았습니다. 먼저 로그인하세요',
      unknownError: '알 수 없는 오류',
      travelCreateFailed: '여행 생성 실패',
      viewProject: '프로젝트 보기',
      // AI 관련 알림
      aiDisabledMessage: 'AI 스마트 추천 기능이 비활성화되었습니다\nAI 일정 생성이 취소되었습니다\n설정에서 다시 활성화할 수 있습니다',
      goToSettings: '설정으로 이동',
    },
    // AI 프롬프트 관련
    aiPrompt: {
      role: '당신은 전문 여행 플래너입니다. 다음 여행 프로젝트에 대해 상세하고 매력적이며 실용적인 일정 소개를 생성해 주세요.',
      // 기본 정보 섹션
      basicInfo: '프로젝트 기본 정보',
      projectNameLabel: '프로젝트 이름',
      destinationLabel: '목적지',
      travelTimeLabel: '여행 기간',
      participantsLabel: '참가자',
      preferencesLabel: '여행 선호도',
      budgetLabel: '1인당 예산',
      noPreferences: '특정 선호도 없음',
      budgetTbd: '예산 미정',
      paymentModeLabel: '결제 모드',
      daysCount: '(총 {days}일)',
      // 결제 모드 매핑
      paymentModes: {
        prepay_average: '사전 균등 결제 모드',
        prepay_share: '사전 셰어 결제 모드',
        actual_average: '실제 비용 균등 모드',
        actual_share: '실제 비용 셰어 모드',
      },
      // 요구 사항 섹션
      requirements: '생성 요구 사항',
      generateContent: '다음 내용을 포함한 일정 소개를 생성해 주세요:',
      contentItems: {
        highlights: '**프로젝트 하이라이트**: 목적지 특징과 사용자 선호도에 기반하여 이 여행의 독특한 점을 강조',
        itinerary: '**상세 일정**: 일별로 구체적인 관광지, 활동 및 경험 계획',
        food: '**음식 추천**: 지역 특산물 및 레스토랑 추천',
        accommodation: '**숙소 제안**: 팀에 적합한 숙소 유형 및 지역',
        transportation: '**교통 가이드**: 목적지로의 이동 방법 및 현지 교통 수단',
        budget: '**예산 참조**: 다양한 비용에 대한 대략적인 예산 범위',
        tips: '**실용적인 팁**: 날씨, 비자, 필수품 및 기타 실용적인 정보 포함',
        teamActivities: '**팀 활동**: {min}명~{max}명 팀에 적합한 특별 활동',
      },
      // 스타일 요구 사항 섹션
      styleRequirements: '스타일 요구 사항',
      styleItems: {
        0: '생동감 있고 흥미로운 언어, 매력적',
        1: '상세하고 구체적인 내용, 실용적',
        2: '팀워크와 사교적 속성을 강조',
        3: '그룹 여행의 경제적 이점과 재미를 반영',
        4: '적절한 이모지를 사용하여 흥미 추가',
        5: '총 단어 수를 400~500단어로 유지',
      },
      generateStart: '생성을 시작하세요:',
    },
  },

  // 여행 상세 페이지
  travelDetail: {
    loading: {
      title: '여행 세부 정보 로드 중...',
      subtitle: '잠시만 기다려 주세요',
    },
    error: {
      title: '로드 실패',
      subtitle: '여행 프로젝트를 찾을 수 없습니다',
      retryButton: '다시 로드',
    },
    actions: {
      editItinerary: '일정 편집',
      approve: '승인',
      reject: '거절',
      settlement: '결제 설정',
    },
    // 페이지 콘텐츠
    content: {
      projectDescription: '프로젝트 설명',
      todoList: 'ToDo 목록',
      members: '여행 멤버',
      add: '추가',
      expand: '펼치기',
      collapse: '접기',
      expandWithCount: '펼치기 ({{count}} 항목)',
      unknownUser: '알 수 없는 사용자',
      creator: '생성자',
      member: '멤버',
      completed: '완료',
      inviteFriends: '친구 초대',
      recommendFriends: '친구 추천',
      noTodos: '아직 ToDo가 없습니다',
      noTodosSubtext: '오른쪽 상단 추가 버튼을 클릭하여 ToDo를 생성하세요',
    },
    // 모달
    modal: {
      paymentSettings: '결제 설정',
      paymentMode: '결제 모드',
      memberShareSettings: '멤버 셰어 설정',
      memberShareDescription: '각 멤버의 셰어 비율을 설정하세요. 예: 성인 1.0, 어린이 0.5, 커플 2.0',
      totalShares: '총 셰어',
      averageMode: '균등 모드',
      shareMode: '셰어 모드',
      prepaidMode: '사전 결제 모드 (여행사 모드, 환불 불가)',
      actualExpenseMode: '실제 비용 모드 (실제 비용으로 분할)',
      currentProjectUses: '현재 프로젝트 사용',
    },
    // 메시지
    messages: {
      success: '성공',
      error: '오류',
      loadFailed: '여행 세부 정보 로드에 실패했습니다',
      unknownError: '알 수 없는 오류',
      userNotLoggedIn: '사용자가 로그인하지 않았습니다',
      paymentSettingsSaved: '결제 설정이 저장되었습니다',
      saveShareSettingsFailed: '셰어 설정 저장에 실패했습니다',
      addTodoFailed: 'ToDo 추가에 실패했습니다',
      batchAddTodosFailed: 'ToDo 일괄 추가에 실패했습니다',
      todosAdded: '{{count}}개 ToDo 추가됨',
      operationFailed: '작업 실패',
      likeFailed: '좋아요 작업이 실패했습니다',
      insufficientPermission: '권한 부족',
      needJoinFirst: '친구를 추천하려면 먼저 프로젝트에 참여해야 합니다',
      onlyCreatorCanInvite: '비공개 프로젝트에서는 생성자만 친구를 초대할 수 있습니다',
      savePaymentModeFailed: '결제 모드 저장에 실패했습니다',
    },
  },

  // 비용 설정 모달
  expenseSettingsModal: {
    // 헤더
    title: '비용 분담 설정',
    cancel: '취소',
    save: '저장',
    // 권한 알림
    permissionNotice: '여행 생성자만 비용 설정을 수정할 수 있습니다',
    // 비용 모드
    expenseModeSection: {
      title: '📊 분담 모드',
      subtitle: '여행 활동에 적합한 비용 관리 방법을 선택하세요',
      // 사전 결제 모드
      prepaidMode: {
        title: '사전 결제 모드',
        subtitle: '멤버가 사전에 지불, 통합 비용 관리',
        description: '관광, 모임 등 예산이 명확한 여행 활동에 적합합니다. 총 예산 설정이 필요합니다.',
        features: [
          '총 예산 금액 설정',
          '멤버가 셰어 비율로 사전 결제',
          '실시간 잔액 추적',
          '환불 또는 추가 결제 정산',
        ],
      },
      // 실제 비용 모드
      actualExpenseMode: {
        title: '실제 비용 모드',
        subtitle: '멤버가 개별적으로 지불하고 나중에 실제 비용으로 분할',
        description: '프로젝트 협업 등 비용이 불확실한 여행 활동에 적합합니다. 예산 설정이 필요 없습니다.',
        features: [
          '영수증 업로드',
          '비용 승인 프로세스',
          '유연한 카테고리 관리',
          '실제 비용 분할',
        ],
      },
    },
    // 셰어 설정
    shareSection: {
      title: '⚖️ 셰어 비율',
      subtitle: '구체적인 비용 분담 방법을 선택하세요',
      toggleTitle: '셰어 기반 분할 활성화',
      // 다양한 모드 설명
      descriptions: {
        prepaidWithShares: '사전 결제 후 실제 소비에 따라 환불 또는 추가 결제, 개인 차이를 고려',
        prepaidWithoutShares: '여행 그룹 모드처럼 생성자가 모든 것을 준비, 균등 분할',
        actualExpenseWithShares: '실제 비용을 멤버 셰어 비율로 분할',
        actualExpenseWithoutShares: '모든 비용을 균등하게 분할, 개인 차이를 고려하지 않음',
      },
      // 셰어 분할 예시
      shareExamples: {
        title: '💡 셰어 분할 안내',
        prepaidMode: '사전 결제 모드 + 셰어 분할:\n• 멤버가 셰어 비율에 따라 다른 금액을 사전 결제\n• 활동 후 실제 소비를 기준으로 재계산\n• 개인 차이를 반영하여 환불 또는 추가 결제\n• 적합: 가족 여행, 친구 모임',
        actualExpenseMode: '실제 비용 + 셰어 분할:\n• 멤버가 개별적으로 지불하고 영수증 업로드\n• 총 비용을 셰어 비율로 분할\n• 최종적으로 차액을 통합 정산\n• 적합: 프로젝트 협업, AA제 모임',
      },
      // 균등 분할 예시
      averageExamples: {
        title: '📋 균등 분할 안내',
        prepaidMode: '사전 결제 모드 + 균등 분할:\n• 모두 동일한 금액을 사전 결제\n• 생성자가 모든 활동을 통합적으로 준비\n• 잔액은 균등하게 환불 또는 지속 사용\n• 적합: 회사 팀 빌딩, 여행 그룹',
        actualExpenseMode: '실제 비용 + 균등 분할:\n• 멤버가 개별적으로 지불하고 영수증 업로드\n• 총 비용을 모두 균등하게 분할\n• 최종적으로 차액을 통합 정산\n• 적합: 임시 활동, 동료 모임',
      },
    },
    // 현재 설정 미리보기
    currentSettings: {
      title: '📋 현재 설정',
      expenseMode: '분담 모드',
      shareMode: '셰어 분할',
      currency: '통화',
      prepaidMode: '사전 결제 모드',
      actualExpenseMode: '실제 비용 모드',
      enabled: '활성화됨',
      averageMode: '균등 분할',
    },
  },

  // 비용 통계
  statistics: {
    title: '여행 통계',
    loading: '통계 계산 중...',
    // 요약 통계
    summary: {
      totalSpent: '총 지출',
      approvedAmount: '승인된 금액',
      averageShare: '평균 셰어',
      averageSpent: '평균 지출',
      budgetUsage: '예산 사용률',
      expenseRecords: '비용 기록',
      approvedReceipts: '승인된 영수증',
      budgetProgress: '예산 사용 상황',
      pending: '보류 중',
      rejected: '거부됨',
      receipts: '영수증',
      groupMode: '그룹 모드: 사전 결제, 균등 분할, 간단한 관리',
    },
    // 카테고리 통계
    categories: {
      title: '비용 카테고리',
      transport: '교통',
      accommodation: '숙소',
      food: '음식',
      activities: '활동',
      shopping: '쇼핑',
      documents: '서류',
      other: '기타',
    },
    // 멤버 통계
    members: {
      shareDetails: '멤버 셰어 세부 정보',
      spentStats: '멤버 지출 통계',
      participation: '멤버 참여도',
      shareAmount: '셰어 금액',
      difference: '차액',
      shouldReceive: '수령해야 할 금액',
      shouldPay: '지불해야 할 금액',
      remainingBalance: '잔액',
      needPayment: '지불 필요',
      balanced: '균형',
      unknownUser: '알 수 없는 사용자',
      totalSpent: '총 지출',
      averagePerPerson: '1인당 평균',
      spent: '지출',
      transactions: '거래',
    },
  },

  // ToDo 추가 모달
  addTodoModal: {
    // 헤더
    title: 'ToDo 항목 추가',
    // 사용자 지정 추가
    customAdd: {
      title: '사용자 지정 추가',
      titleLabel: '제목',
      titlePlaceholder: 'ToDo 항목 제목을 입력하세요',
      descriptionLabel: '설명',
      descriptionPlaceholder: '상세 설명을 입력하세요 (선택 사항)',
      priorityLabel: '우선순위',
    },
    // 우선순위
    priority: {
      high: '높음',
      medium: '중간',
      low: '낮음',
    },
  },

  // 친구 초대 화면
  inviteFriends: {
    header: {
      title: '친구 초대',
      subtitle: '"{{groupName}}"에 친구 초대',
    },
    search: {
      placeholder: '친구 검색...',
    },
    sections: {
      available: '초대 가능한 친구',
      members: '이미 멤버',
      pending: '보류 중인 초대',
    },
    status: {
      joined: '이미 프로젝트에 참여함',
      invitationSent: '초대 전송됨, 답변 대기 중',
    },
    actions: {
      sendInvitations: '초대 보내기',
      sending: '보내는 중...',
      continueInviting: '계속 초대',
      goBack: '뒤로 가기',
    },
    loading: {
      text: '친구 목록 로드 중...',
    },
    empty: {
      noFriends: {
        title: '친구 없음',
        subtitle: '먼저 친구를 추가하세요',
      },
      noResults: {
        title: '검색 결과 없음',
        subtitle: '다른 키워드를 시도하세요',
      },
    },
    selection: {
      count: '{{count}}명 친구 선택됨',
      sendCount: '초대 보내기 ({{count}})',
    },
    alerts: {
      selectFriends: '초대할 친구를 선택하세요',
      userInfoFailed: '사용자 정보 가져오기에 실패했습니다',
      invitationSuccess: '초대가 성공적으로 전송되었습니다',
      invitationSuccessMessage: '{{names}}에게 초대가 전송되었습니다',
      loadFriendsFailed: '친구 목록 로드에 실패했습니다',
      sendInvitationsFailed: '초대 전송에 실패했습니다',
      error: '오류',
      hint: '힌트',
      unknownError: '알 수 없는 오류',
      unknownUser: '알 수 없는 사용자',
    },
  },

  // 목적지 데이터
  destinations: {
    countries: {
      // 아시아
      CN: 'China',
      HK: 'Hong Kong',
      MO: 'Macau',
      TW: 'Taiwan',
      JP: 'Japan',
      KR: 'South Korea',
      TH: 'Thailand',
      SG: 'Singapore',
      MY: 'Malaysia',
      VN: 'Vietnam',
      ID: 'Indonesia',
      IN: 'India',
      AE: 'United Arab Emirates',
      // 유럽
      GB: 'United Kingdom',
      FR: 'France',
      DE: 'Germany',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'Netherlands',
      CH: 'Switzerland',
      // 북아메리카
      US: 'United States',
      CA: 'Canada',
      // 오세아니아
      AU: 'Australia',
      NZ: 'New Zealand',
    },
    cities: {
      // 도시별 목적지
      HongKong: '홍콩',
      Macau: '마카오',
      Singapore: '싱가포르',
      // 중국 도시
      Beijing: '베이징',
      Shanghai: '상하이',
      Guangzhou: '광저우',
      Shenzhen: '선전',
      Hangzhou: '항저우',
      Chengdu: '청두',
      // 대만 도시
      Taipei: '타이베이',
      Kaohsiung: '가오슝',
      Taichung: '타이중',
      Tainan: '타이난',
      // 일본 도시
      Tokyo: '도쿄',
      Osaka: '오사카',
      Kyoto: '교토',
      Nagoya: '나고야',
      Fukuoka: '후쿠오카',
      Sapporo: '삿포로',
      // 한국 도시
      Seoul: '서울',
      Busan: '부산',
      Daegu: '대구',
      Incheon: '인천',
      // 태국 도시
      Bangkok: '방콕',
      ChiangMai: '치앙마이',
      Phuket: '푸켓',
      Pattaya: '파타야',
      // 말레이시아 도시
      KualaLumpur: '쿠알라룸푸르',
      Penang: '페낭',
      Malacca: '말라카',
      JohorBahru: '조호르바루',
      // 베트남 도시
      HoChiMinhCity: '호치민',
      Hanoi: '하노이',
      DaNang: '다낭',
      NhaTrang: '나트랑',
      // 인도네시아 도시
      Jakarta: '자카르타',
      Bali: '발리',
      Yogyakarta: '족자카르타',
      Surabaya: '수라바야',
      // 인도 도시
      NewDelhi: '뉴델리',
      Mumbai: '뭄바이',
      Bangalore: '방갈로르',
      Kolkata: '콜카타',
      // 아랍에미리트 도시
      Dubai: '두바이',
      AbuDhabi: '아부다비',
      // 영국 도시
      London: '런던',
      Edinburgh: '에든버러',
      Manchester: '맨체스터',
      Liverpool: '리버풀',
      // 프랑스 도시
      Paris: '파리',
      Lyon: '리옹',
      Marseille: '마르세유',
      Nice: '니스',
      // 독일 도시
      Berlin: '베를린',
      Munich: '뮌헨',
      Hamburg: '함부르크',
      Frankfurt: '프랑크푸르트',
      // 이탈리아 도시
      Rome: '로마',
      Milan: '밀라노',
      Venice: '베네치아',
      Florence: '피렌체',
      // 스페인 도시
      Madrid: '마드리드',
      Barcelona: '바르셀로나',
      Valencia: '발렌시아',
      Seville: '세비야',
      // 네덜란드 도시
      Amsterdam: '암스테르담',
      Rotterdam: '로테르담',
      TheHague: '헤이그',
      // 스위스 도시
      Zurich: '취리히',
      Geneva: '제네바',
      Basel: '바젤',
      // 미국 도시
      NewYork: '뉴욕',
      LosAngeles: '로스앤젤레스',
      Chicago: '시카고',
      SanFrancisco: '샌프란시스코',
      LasVegas: '라스베이거스',
      Miami: '마이애미',
      // 캐나다 도시
      Toronto: '토론토',
      Vancouver: '밴쿠버',
      Montreal: '몬트리올',
      Ottawa: '오타와',
      // 호주 도시
      Sydney: '시드니',
      Melbourne: '멜버른',
      Brisbane: '브리즈번',
      Perth: '퍼스',
      // 뉴질랜드 도시
      Auckland: '오클랜드',
      Wellington: '웰링턴',
      Christchurch: '크라이스트처치',
    },
  },

  // 여행 채팅
  travelChat: {
    header: {
      title: '{{groupName}} 채팅방',
      subtitle: '여행 그룹 채팅',
    },
    loading: {
      text: '채팅 기록 로드 중...',
    },
    empty: {
      title: '아직 채팅 기록이 없습니다',
      subtitle: '팀원들과 채팅을 시작하세요!',
    },
    input: {
      placeholder: '메시지를 입력하세요...',
    },
    time: {
      today: '오늘',
      yesterday: '어제',
    },
    errors: {
      sendFailed: '전송 실패',
      networkError: '네트워크 오류, 다시 시도하세요',
    },
    user: {
      unknown: '알 수 없는 사용자',
    },
  },

  // 비용 관리
  expenseManagement: {
  fullAmount: '전체 금액',
    ledgerTabs: {
      public: '그룹 장부',
      private: '개인 장부',
    },
    // 통계
    statistics: {
      title: '비용 통계',
      settings: '설정',
      consumed: '소비됨',
      totalExpense: '총 비용',
      approvedReceipts: '승인된 영수증',
      pendingReview: '검토 대기 중',
      averagePerPerson: '1인당 평균',
      averagePerShare: '셰어당 평균',
      categoryStatistics: '비용 카테고리 통계',
      shareMode: '셰어 분할',
      averageMode: '균등 모드',
      perSharePayable: '셰어당 지불액',
      averageSplit: '균등 분할',
    },
    // 영수증
    receipts: {
      title: '영수증',
      upload: '업로드',
      exportPDF: 'PDF',
      exporting: '내보내는 중...',
      approve: '승인',
      reject: '거부',
      confirmTitle: '작업 확인',
      confirmApprove: '이 영수증을 승인하시겠습니까?',
      confirmReject: '이 영수증을 거부하시겠습니까?',
      cancel: '취소',
      confirm: '확인',
      approved: '영수증이 승인되었습니다',
      rejected: '영수증이 거부되었습니다',
      success: '작업 성공',
      error: '작업 실패',
      approveFailed: '승인 실패',
      rejectFailed: '거부 실패',
      operationFailed: '작업 실패',
      imageUnavailable: '이미지 사용 불가',
      imageLoadError: '이미지 로드 오류',
      cannotDisplay: '이미지를 표시할 수 없습니다',
      emptyTitle: '영수증 없음',
      emptySubtitle: '위의 "업로드" 버튼을 클릭하여 첫 영수증을 추가하세요',
    },
    privateReceipts: {
      modeInfo: '이곳은 구성원이 개인적으로 기록한 장부이며 개인 정산에만 영향을 줍니다.',
      loading: '개인 장부 내역을 불러오는 중…',
      loadFailed: '개인 장부 내역을 불러오지 못했어요',
      loadFailedHint: '네트워크 연결을 확인한 뒤 다시 시도해주세요.',
      retry: '다시 시도',
      emptyTitle: '개인 장부 내역이 아직 없습니다',
      emptySubtitle: '구성원이 자신의 개인 영수증을 업로드하거나 상단의 “업로드” 버튼으로 첫 소비를 기록해 보세요.',
      settlementTitle: '멤버 간 정산',
      settlementAmount: '{{payer}}님이 {{receiver}}에게 {{amount}}을(를) 보내야 해요',
      settlementYouOwe: '당신은 {{receiver}}에게 {{amount}}을(를) 보내야 해요',
      settlementOwesYou: '{{payer}}님이 당신에게 {{amount}}을(를) 보내야 해요',
      settlementEmpty: '모두 정산 완료! 남아 있는 개인 잔액이 없습니다.',
      noPersonalSettlements: '당신에게 관련된 개인 정산이 없습니다.',
      noPersonalReceipts: '당신이 참여한 개인 영수증이 아직 없어요.',
      noPersonalReceiptsSubtitle: '다른 구성원끼리의 개인 장부는 여기에서 보이지 않아요.',
      youLabel: '당신',
      vsSeparator: ' vs ',
    },
    // 상태
    status: {
      pending: '보류 중',
      approved: '승인됨',
      rejected: '거부됨',
    },
    // 거부 사유
    rejectionReason: {
      title: '거부 사유',
    },
    // 거부 입력
    rejectInput: {
      title: '영수증 거부',
      label: '거부 사유를 입력하세요:',
      placeholder: '이 영수증을 거부하는 자세한 이유를 입력해주세요...',
      cancel: '취소',
      confirm: '거부 확인',
    },
    // 멤버 잔액
    memberBalance: {
      title: '멤버 잔액',
      paid: '지불 완료',
      shouldPay: '지불해야 할 금액',
      overpaid: '초과 지불',
      owes: '미지불',
      share: '셰어',
    },
    // 결제 모드
    paymentMode: {
      prepaid: '사전 결제 모드',
      actualExpense: '실제 비용',
      shareMode: '셰어 모드',
      equalMode: '균등 모드',
    },
    // 카테고리 통계
    categoryStats: {
      title: '카테고리 통계',
      total: '총계',
    },
    // 카테고리
    categories: {
      transport: '교통',
      accommodation: '숙소',
      food: '음식 및 식사',
      flight: '항공',
      taxi: '택시',
      attractions: '관광지',
      shopping: '쇼핑',
      entertainment: '엔터테인먼트',
      insurance: '보험',
      visa: '비자',
      communication: '통신',
      general: '기타',
    },
    // 내보내기
    export: {
      error: '내보내기 실패',
      noData: '내보낼 데이터가 없습니다',
      success: '내보내기 성공',
      successMessage: 'PDF 보고서가 생성되어 공유 준비가 되었습니다',
      failed: '내보내기 실패, 다시 시도하세요',
    },
    // PDF 보고서 번역
    pdfReport: {
      title: '비용 보고서',
      subtitle: '재무 세부 정보 및 통계 분석',
      generatedBy: 'PDF 생성자',
      brandName: 'Cube Meet',
      brandWebsite: 'https://cubemeet.app',
      generatedAt: '생성 시각',
      brandFooter: 'Cube Meet - 스마트 재무 관리 플랫폼 제공',
      brandSlogan: '스마트한 삶, 비용 추적에서 시작',
      // 섹션 제목
      sections: {
        overview: '재무 개요',
        memberBalances: '멤버 잔액 세부 정보',
        expenseDetails: '비용 세부 정보',
        receipts: '비용 영수증 세부 정보',
        categoryStats: '비용 카테고리 통계',
        categoryBreakdown: '카테고리 내역',
      },
      // 개요 항목
      overview: {
        totalExpense: '총 비용',
        memberCount: '멤버 수',
        approvedReceipts: '승인된 영수증',
        pendingReceipts: '보류 중인 영수증',
        memberUnit: '멤버',
        receiptUnit: '영수증',
      },
      // 테이블 헤더
      tableHeaders: {
        member: '멤버',
        spent: '지출',
        shouldPay: '지불해야 할 금액',
        balance: '잔액',
        share: '셰어',
        title: '제목',
        amount: '금액',
        category: '카테고리',
        date: '날짜',
        uploader: '업로더',
        status: '상태',
        percentage: '비율',
        unknown: '알 수 없음',
      },
      // 상태 번역
      status: {
        approved: '승인됨',
        rejected: '거부됨',
        pending: '보류 중',
        unknown: '알 수 없음',
      },
      // 잔액 상태
      balanceStatus: {
        overpaid: '초과 지불',
        owed: '미지불',
      },
    },
  },

  // 홈
  home: {
    welcomeBack: '환영합니다',
    discoverTravel: '여행 탐색',
    discoverPlans: '멋진 여행 계획을 발견하세요',
    whereToGo: '어디로 떠나시나요?',
    viewMore: '더 보기',
    recommendedCards: '추천 카드',
    latestPosts: '최신 여행기',
    loginPrompt: '로그인하여 일정 생성 및 관리',
    loginButton: '로그인 / 가입',
  },

  // 카드 목록
  cardList: {
    title: '카드 둘러보기',
    searchPlaceholder: '카드 검색...',
    types: {
      poi: '명소',
      restaurant: '맛집',
      lodging: '숙소',
      activity: '액티비티',
      shopping: '쇼핑',
    },
    filters: {
      tags: '태그',
      category: '카테고리',
      subcategory: '하위 카테고리',
      location: '지역',
      clear: '초기화',
    },
    status: {
      loading: '로딩 중...',
      switchingPages: '페이지 전환 중...',
      noMore: '더 이상 카드가 없습니다',
      emptyTitle: '카드를 찾을 수 없습니다',
      emptyText: '검색 조건이나 필터를 조정해보세요',
    },
    modal: {
      title: '카드 상세',
      close: '닫기',
      addToItinerary: '일정에 추가',
    }
  },

  // 카드 상세 페이지
  cardDetail: {
    tabs: {
      book: '예약',
      details: '상세 정보',
      nearby: '주변 명소',
      description: '설명',
    },
    gallery: {
      allPhotos: '모든 사진',
      tripPhotos: '여행 사진',
      addPhoto: '사진 추가',
    },
    affiliate: {
      bookOn: '{{brand}}에서 예약',
      searchOn: '{{brand}}에서 검색',
    },
  },

  // 여행 게시물 상세
  travelPostDetail: {
    loading: '로딩 중...',
    emptyContent: '아직 내용 없음',
    meta: {
      defaultTitle: '여행 노트',
      siteName: 'Cubemeet',
    },
    breadcrumbs: {
      home: '홈',
      city: '도시',
      guide: '가이드',
    },
    messages: {
      cloneSuccess: '일정이 복사되었습니다. 리디렉션 중...',
      cloneFailed: '일정 복사에 실패했습니다. 나중에 다시 시도해 주세요',
      postNotFound: '게시물을 찾을 수 없거나 삭제되었습니다',
      loadFailed: '게시물 로드 실패',
      followFailed: '팔로우 실패',
      followed: '팔로우됨',
      noMapData: '지도 데이터 없음',
    },
    actions: {
      retry: '재시도',
      back: '뒤로',
      backToTop: '맨 위로',
      cloneToItinerary: '내 일정으로 복사',
      viewMap: '지도 보기',
    },
    error: {
      notFound: '게시물을 찾을 수 없습니다',
    },
    cloneModal: {
      title: '내 일정으로 복사',
      labelTitle: '일정 제목',
      placeholderTitle: '일정 제목 입력',
      labelStartDate: '시작 날짜',
      cancel: '취소',
      confirm: '복사 확인',
      copyOf: 'Copy of',
    },
    postEngagement: {
      auth: {
        authenticated: '인증됨',
        unauthenticated: '미인증',
        pleaseLogin: '댓글을 작성하려면 로그인하세요',
        checkFailed: '인증 확인 실패',
      },
      comment: {
        anonymous: '익명 사용자',
        empty: '댓글 내용이 비어 있습니다',
        start: '댓글 게시 중...',
        success: '댓글이 게시되었습니다',
        reload: '댓글 다시 로드 중...',
        failed: '댓글 게시 실패',
        unknownError: '알 수 없는 오류',
        placeholder: '댓글을 입력하세요...',
        sending: '전송 중...',
        send: '전송',
        total: '댓글 {{count}}개',
        loading: '댓글 로드 중...',
        loadMore: '댓글 더 보기',
        avatarError: '아바타 로드 실패',
      },
      time: {
        justNow: '방금 전',
        minsAgo: '{{count}}분 전',
        hoursAgo: '{{count}}시간 전',
        daysAgo: '{{count}}일 전',
      },
      badge: {
        author: '작성자',
        admin: '관리자',
        agency: '인증됨',
      },
      richContent: {
        imageLoadFailed: '이미지 로드 실패:',
        imageAlt: '이미지',
        empty: '내용 없음',
      },
    },
  },

  snapshot: {
    noContent: '콘텐츠 없음',
    imageLoadFailed: '이미지 로드 실패',
    day: '{{number}}일차',
    openCardDetails: '카드 상세 열기',
    openCardInNewWindow: '새 창에서 카드 열기',
    prevImage: '이전 이미지',
    nextImage: '다음 이미지',
  },
};